module.exports = __webpack_public_path__ + "static/media/campground.e59afae4.svg";